import { connect } from 'react-redux';
import React, { Component } from 'react';
import { api, apiUtils } from 'app/services';

var ReplacementBox = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();}getInitialState()

  {
    return {
      tags: [] };

  }componentDidMount()
  {
    api.getActivitiesHotTags().then(({ json }) => {
      this.setState({
        tags: json || [] });

    });
  }render()
  {
    const { tags } = this.state;
    const childrenWithProps = React.Children.map(this.props.children, (child) =>
    React.cloneElement(child, { tags }));

    return <div className="clear-fix">{childrenWithProps}</div>;
  }};


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ReplacementBox);
